import React, {useEffect, useState} from 'react'
import {gql} from 'apollo-boost';
import {get, groupBy, findIndex, startCase, toLower} from 'lodash';
import {Grid, Box} from '@material-ui/core';
import styled from 'styled-components';
import {isWidthUp} from '@material-ui/core/withWidth';
import withWidth from '../../../../src/components/hoc/withWidth';
import {theme} from '../../../../src/themes/default-theme';
import client from '../../../../src/graphql/client';
import seriesHBQuery from '../../../../src/graphql/queries/series-hero-banner';
import modelFloorPlansUriQuery from '../../../../src/graphql/queries/model-uris';
import contentBuilderQuery from '../../../../src/graphql/queries/series-content-builder';
import respImgQuery from '../../../../src/graphql/queries/resp-img';
import financeQuery from '../../../../src/graphql/queries/finance-banner';
import seoQuery from '../../../../src/graphql/queries/seo';
import refactorSeriesData from '../../../../src/data-restructure/pages/series';
import getParamsWithModel from '../../../../src/data-restructure/pages/series/model-uris';
import {getItems, saveItem, removeItem} from '../../../../src/util/savedCaravans';
import { getRecentlyViewed, saveRecentlyViewed } from '../../../../src/util/recentlyViewed';
import Disclaimer from '../../../../src/components/ui/Disclaimer';
import ReactHtmlParser from 'react-html-parser';

import Banner from '../../../../src/components/multimedia/SeriesHeroBanner';
// import BannerPopup from '../../../../src/components/ui/BannerPopup';
import RecentlyViewed from '../../../../src/components/navigation/RecentlyViewed';

import dlPush from '../../../../src/util/dlPush';
import refactorFinanceRates from '../../../../src/data-restructure/data/repayment-calc-rates';
import financeRatesQuery from '../../../../src/graphql/queries/finance-rates';

import {getModelFloorPlanData} from '../../../../src/data-restructure/pages/series/model-data';

// import SeriesPage from '../../../../src/containers/SeriesPage';
import ContentBuilderV2 from '../../../../src/containers/ContentBuilderV2'
import SubNav from '../../../../src/components/navigation/NewSubNav';



// import refactorSpecs from '../../../../src/data-restructure/pages/floor-plans/specs';
// import refactorSpecTabs from '../../../../src/data-restructure/pages/floor-plans/spec-tabs';
// import refactorFloorPlanTabs from '../../../../src/data-restructure/pages/floor-plans/floor-plan-tabs';

const Container = styled.div`
    background-color: ${props => props.bg};
`

const DisclaimerWrapper = styled.div`
  padding: 30px 0;

  ${props => props.background === 'light' ? 
    `background-color: ${theme.palette.lightGrey};`
    : 
    `background-color: ${theme.palette.shadeBlack};
     color: white;
    `
  }
  
`


const SeriesPage = (props) => {

  const [savedItems, setSavedItems] = useState([]);
  const [curWidth, updateCurWidth] = useState(props.width);
  const [compareItems, setCompareItems] = useState([]);
  const [recentlyViewedItems, setRecentlyViewedItems] = useState(null)
  const [activeScrollItem, setActiveScrollItem] = useState(null)

  console.log('seriespage', props);

  useEffect(() => {
    // If width changes from md to sm/xs & compare items length is at max then clear items (2 items for sm, 3 for md up)
    if (
      ((compareItems.length === 3) && curWidth !== 'sm' && curWidth !== 'xs') && (props.width === 'sm' || props.width === 'xs')
    ) {
      setCompareItems([])
    }
    updateCurWidth(props.width);
  }, [props.width]);

  const setSaved = () => {
    const savedCaravans = get(window, 'localStorage.savedCaravans', null);
    if (savedCaravans && savedCaravans.length > 0) {
      const parsedSavedCaravans = JSON.parse(savedCaravans);
      setSavedItems(parsedSavedCaravans.map(item => item.id));
    }
  }

  const isSaved = (item) => {
    const items = process.browser ? getItems() : [];
    return items && items.length > 0 ? (findIndex(items, { type: 'series', id: get(item, 'id', null)} ) !== -1 ? true : false) : false
  }

  const handleSave = (item) => {    
    const data = item ? {
      ...item,
      uri: item.href
    } : {
      ...props.modelData,
      uri: props.router.asPath
    };
    const saved = isSaved(data);
    (data.id && saved) ? removeItem({type: 'series', id: data.id, data}) : saveItem({type: 'series', id: data.id, data});
  }

  useEffect(() => {
    document.addEventListener("ls:change", setSaved);
    return () => window.removeEventListener("ls:change", setSaved);
  })

  useEffect(() => {
    setSaved();
    recentlyViewed();
  },[props.modelData.id])

  const recentlyViewed = () => {
    saveRecentlyViewed(props.modelData.id);

    const recentlyViewedData = getRecentlyViewed() || [];


    const recentlyViewedIds = recentlyViewedData.filter(item => {
      return item !== get(props, 'modelData.id', null);
    })

    // const recentlyViewed = props.allSeriesThumbnails.filter(item => {
    //   return recentlyViewedIds.indexOf(item.id) !== -1 && item.id !== props.modelData.id
    // })

    const recentlyViewed = recentlyViewedIds.map(item => {
      return props.allSeriesThumbnails.find(series => series.id === item);
    })

    console.log('recentlyViewedData', {recentlyViewedData, recentlyViewedIds, recentlyViewed, allSeriesThumbnails: props.allSeriesThumbnails});

    recentlyViewed && recentlyViewed.length > 0 && setRecentlyViewedItems(recentlyViewed)
  }

  const saved = savedItems.indexOf(props.modelData.id) !== -1 ? true : false

  const handleCtaClick = (type, item) => {
    if (type === 'ctaBanner' && item.href === '/find-a-dealer') {
      dlPush({
        'event': 'jaycoEvent',
        'eventAction': 'CTA Click - Find a Dealer',
        'eventCategory': 'Ready to Buy',
        'eventLabel': 'Adventure CTA'  
      })
    }
    if (type === 'ctaBanner' && item.href === '/brochure-request') {
      dlPush({
        'event': 'jaycoEvent',
        'eventAction': 'CTA Click - Request Brochure',
        'eventCategory': 'Research',
        'eventLabel': 'Adventure CTA'
      })
    }

    if (type === 'ctaBanner' && item.href === '/book-a-viewing') {
      dlPush({
        'event': 'jaycoEvent',
        'eventAction': 'CTA Click - Book a Viewing',
        'eventCategory': 'Research',
        'eventLabel': 'Adventure CTA'
      })
    }

    if (type === 'intro' && item.href === '/book-a-viewing') {
      dlPush({
        'event': 'jaycoEvent',
        'eventAction': 'CTA Click - Request a Viewing',
        'eventCategory': 'Research',
        'eventLabel': window.location.pathname, // requestViewingLink
      })
    }

    if (type === 'intro' && item.href === '/brochure-request') {
      dlPush({
        'event': 'jaycoEvent',
        'eventAction': 'CTA Click - Request Brochure',
        'eventCategory': 'Research',
        'eventLabel': 'Primary CTA'
      })
    }
  }

  const handleShareClick = (platform) => {
    const model = get(props, 'modelData.title', null)
      dlPush({
        'event': 'jaycoEvent',
        'eventAction': 'Share Model Details',
        'eventCategory': 'Research',
        'eventLabel': `${platform} ${model}`
      })
  }

  const handleNextClick = () => {
    dlPush({
      'event': 'jaycoEvent',
      'eventAction': 'CTA Click - Our Range - Compare',
      'eventCategory': 'Research',
      'eventLabel': 'Next'
    })
  }

  const colourTheme = props.theme === 'white' || props.theme === 'light' ? 'light' : 'dark';

  const handleIntersection = (e,item) => {
    console.log('active id1234', e, item);
    if (e) {
      // setActiveScrollItem(item)
    }
  }

  console.log('seriesPage', props);
 
  return (
    <>
      <Container bg={props.theme === 'black' ? 'black' : 'white'}>
        {props.subNav && 
            <SubNav 
                {...props.subNav}
                onShareClick={handleShareClick}
                onSave={() => handleSave()}
                saved={saved}
                activeScrollItem={activeScrollItem}
                hasBreadcrumbs={props.breadcrumbs?.list?.length > 0 ? true : false}
                breadcrumbsHeight={props.breadcrumbsHeight ? props.breadcrumbsHeight : 0}
            />
        }
        {props.heroBanner &&
          <Banner
            {...props.heroBanner}
            colourTheme={colourTheme}
            onShareClick={handleShareClick}
            onSave={() => handleSave()}
            saved={saved}
          />
        }
        {props.cbData &&
          <ContentBuilderV2
            rates={props.rates} 
            items={props.cbData}
            colourTheme={colourTheme}
            uri={props.router.asPath}
            seriesId={props.seriesId}
            rangeId={props.rangeId}
            rangeTitle={props.rangeTitle}
            onIntersection={handleIntersection}
            motorised={props.motorised}
            countryProps={props.countryProps}
          />
        }

        {recentlyViewedItems &&
          <RecentlyViewed 
            series={
              recentlyViewedItems
            }
            background={colourTheme}
          />
        }

        <DisclaimerWrapper background={colourTheme}>
          <Grid container className={'hasPadding'} spacing={0} direction={'row'} wrap="nowrap" justify={'space-between'}>
            <Grid item xs={12}>
              <Box px={2}>
                <Disclaimer>
                  {props.disclaimers && ReactHtmlParser(props.disclaimers)}
                </Disclaimer>
              </Box>
            </Grid>
          </Grid>
        </DisclaimerWrapper>
      </Container>
    </>
  )
}


export async function getStaticPaths() {

  const GET_DYNAMIC_PATHS_QUERY = gql `
    query GET_SERIES_PATHS {
      ranges(first: 1000) {
        nodes {
          acf_range {
            rangeSeriesRef {
              ... on Series {
                uri
                acf_domains {
                  assignedDomains
                }
              }
            }
          }
          uri
        }
      }
    }
  `

  const result = await client.query({
    query: GET_DYNAMIC_PATHS_QUERY
  });

  let paths = [];

  const ranges = get(result, 'data.ranges.nodes', []);
  
  const countryCode = process.env.DEV_COUNTRY_CODE ? process.env.DEV_COUNTRY_CODE.toLowerCase() : process.env.COUNTRY_CODE.toLowerCase();
  const domain = countryCode === 'au' ? 'jayco.com.au' : 'jayco.co.nz';

  ranges.forEach(item => {
    const range = item.uri;
    const seriesArr = get(item, 'acf_range.rangeSeriesRef', null);
    seriesArr && seriesArr.forEach(series => {
      const seriesAssignedDomains = get(series, 'acf_domains.assignedDomains', []);
      if (series && series.uri && seriesAssignedDomains.indexOf(domain) !== -1) {
        paths.push({
          params: {
            range,
            series: series.uri
          }
        })
      }
    })
  });

  return { paths , fallback: false }

}

export async function getStaticProps(context) {

  var startTime = new Date().getTime();

  const {
    params
  } = context

  const countryCode = process.env.DEV_COUNTRY_CODE ? process.env.DEV_COUNTRY_CODE.toLowerCase() : process.env.COUNTRY_CODE.toLowerCase();

  const GET_DYNAMIC_SERIES_PROPS = gql`
    query GET_SERIES_DATA($uri: String) {
      series(first: 10000) {
        nodes {
          id
          uri
          title
          seriesId
          acf_series {
            seriesRange {
              ... on Range {
                id
                rangeId
                uri
                title
              }
            }
            seriesImage {
              ${respImgQuery}
            }
            seriesToilet
            seriesShower
            seriesFridge
            sleepingMax
            sleepingMin
            seriesSpecsRep {
              seriesSpecRepTitle
              seriesSpecRepFeaturedModel {
                ... on ModelFloorPlan {
                  id
                  modelFloorPlanId
                }
              }
            }
          }
        }
      }
      seriesBy(uri: $uri) {
        id
        link
        seriesId
        title
        seo {
          ${seoQuery}
        }
        ${contentBuilderQuery('Series_AcfSeriesContentBuilder')}
        acf_domains {
          assignedDomains
        }
        acf_series {
          seriesRange {
            ... on Range {
              id
              rangeId
              title
            }
          }
          seriesImage {
            ${respImgQuery}
          }
          seriesDescriptionWithCtas {
            seriesDctaDescription
            seriesDctaHeading
            seriesDctaCtasRep {
              seriesDctaColour
              seriesDctaLink {
                target
                title
                url
              }
            }
          }
          ${seriesHBQuery}
          seriesToilet
          seriesShower
          seriesFridge
          sleepingMax
          sleepingMin
          
          seriesSpecsRep {
            seriesSpecRepTitle
            seriesSpecRepFeaturedModel {
              ... on ModelFloorPlan {
                id
                acf_floor_plan {
                  modelLayoutName
                  modelExternalImagesRep {
                    modelExternalImagesRepImage {
                      ${respImgQuery}
                    }
                  }
                }
              }
            }
          }
          seriesDisclaimer {
            ... on Disclaimer {
              id
              acf_disclaimer {
                disclaimerText
              }
            }
          }
        }
        acf_series_v2 {
          sv2Theme
          sv2SubnavColour
          sv2SubnavLogo {
            ${respImgQuery}
          }
          sv2HeroBanner {
            sv2hbImage {
              ${respImgQuery}
            }
            title
            subtitle
            text
            ctas {
              link {
                title
                url
                target
              }
              style
            }
            series {
              title
              carousel {
                sv2hbsImage {
                  ${respImgQuery}
                }
              }
            }
          }
          sv2FloorPlansSectionTitle
          sv2FloorPlansLink360Pretitle
          sv2FloorPlansLink360Title
        }
        acf_motorised {
          motorisedModel {
            ... on MotorisedModel {
              id
              acf_motorised_model {
                motorisedMakeModelName
                motorisedFeaturedFloorplan {
                  ... on ModelFloorPlan {
                    id
                    acf_floor_plan {
                      modelLayoutId
                      modelLayoutName
                      modelExternalImagesRep {
                        modelExternalImagesRepImage {
                          ${respImgQuery}
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        acf_calculator_modal {
          cmCtaText
          cmTitle
          cmSubtext
          cbImage {
            ${respImgQuery}
          }
        }
      }
      ${modelFloorPlansUriQuery}
      ${financeRatesQuery}
      modelsFloorPlans(first: 10000) {
        nodes {
          id
          title
          uri
          acf_domains {
            assignedDomains
          }
          acf_floor_plan {
            modelHasFridge
            modelHasKitchen
            modelHasShower
            modelHasToilet
            modelSleepAdultStandard
            modelSleepChildrenStandard
            modelSleepAdditionalStandard
            modelStandardFloorPlanDescription
            modelStandardFloorPlanBottomDescription
            modelNewFloorPlanBadge
            modelStandardFloorPlanMostPopularBadge
            modelFloorPlanConfigurations {
              title
              configurationMostPopularBadge
              image {
                ${respImgQuery}
              }
              mcfgImage {
                ${respImgQuery}
              }
              mcfgImageNight {
                ${respImgQuery}
              }
              description
              bottomDescription
              sleepAdult
              sleepChildren
              sleepAdditional
              additionalPrice
            }
            seriesSpec
            modelLayoutId
            modelLayoutName
            modelHidePricing
            modelFeatures
            modelToilet
            modelFridge
            modelShower
            modelBodyLength
            modelWeightTare
            modelWeightTowBall
            modelInteriorHeight
            modelOpenLength
            modelFrontBedWidth
            modelRearBedWidth
            modelTravelHeight
            modelTravelLength
            modelTravelWidth
            modelWidthIncAwning
            modelSleepsAdult
            modelSleepsChild
            modelSleepsOptional
            modelFinanceOfferRef {
              ${financeQuery}
            }
            modelSeries {
              ... on Series {
                id
                uri
                title
                acf_series {
                  rangeAssigned
                  seriesHidePricing
                  seriesRange {
                    ... on Range {
                      uri
                      id
                      title
                    }
                  }
                  seriesFloorPlansPageHeroBanner {
                    seriesFphbHeadingText
                    seriesFphbSubheading1Text
                    seriesFphbSubheading2Text
                    seriesFphbVideoDesktop {
                      guid
                      mimeType
                      id
                    }
                    seriesFphbVideoMobile {
                      guid
                      mimeType
                      is
                    }
                    seriesFphbImage {
                      ${respImgQuery}
                    }
                  }
                  seriesSpecsRep {
                    seriesSpecRepTitle
                    seriesSpecRepDescription
                  }
                }
                acf_domains {
                  assignedDomains
                }
              }
            }
            model360TourLink
            modelFloorPlanImage {
              ${respImgQuery}
            }
            modelFloorPlanImageNight {
              ${respImgQuery}
            }
            modelExternalImagesRep {
              modelExternalImagesRepImage {
                ${respImgQuery}
              }
            }
          }
          acf_motorised {
            motorisedModel {
              ... on MotorisedModel {
                id
                acf_motorised_model {
                  motorisedMakeModelName
                  motorisedLogo {
                    ${respImgQuery}
                  }
                  motorisedFeaturedFloorplan {
                    ... on ModelFloorPlan {
                      id
                      acf_floor_plan {
                        modelExternalImagesRep {
                          modelExternalImagesRepImage {
                            ${respImgQuery}
                          }
                        }
                      }
                    }
                  }
                  motorisedDescription
                }
              }
            }
          }
          acf_motorised_floorplan_specs_table {
            mfpstBodyLength
            mfpstGrossVehicleMass
            mfpstInteriorHeight
            mfpstInteriorLength
            mfpstTowingCapacity
            mfpstTravelHeight
            mfpstTravelWidth
            mfpstDrivenWheels
            mfpstEngine
            mfpstTransmission
          }
        }
      }
      dealers(first: 1000) {
        nodes {
          title
          acf_dealers {
            dealerID
            latitude
            longitude
            postcodes
          }
        }
      }
    }
  `

  const pageProps = await client.query({
    query: GET_DYNAMIC_SERIES_PROPS,
    variables: {
      uri: params.series
    }
  });

  const data = get(pageProps, 'data.seriesBy', {});
  const series = get(pageProps, 'data.series', {});
  const modelFloorplans = get(pageProps, 'data.modelsFloorPlans.nodes', {}); 
  // const paramsWithModel = getParamsWithModel(params, pageProps);


  // //
  // // TABS
  // const filteredFp = refactorSpecs(modelFloorplans, context.params);
  // const tabsData = get(filteredFp, '[0]acf_floor_plan.modelSeries[0].acf_series.seriesSpecsRep', null);

  // const seriesUrl = `/range/${params.range}`;
  // const url = `${seriesUrl}/${params.series}/floor-plans/`;
  // const trimTabs = modelFloorplans ? modelFloorplans.map(item => {
  //   const seriesSpec = get(item, 'acf_floor_plan.seriesSpec', null)
  //   const seriesUri = get(item, 'acf_floor_plan.modelSeries[0].uri', null)
  //   const layoutName = get(item, 'acf_floor_plan.modelLayoutName', null)

  //   return {
  //     series: seriesSpec ? seriesSpec.trim() : null,
  //     uri: item.uri,
  //     seriesUri,
  //     layoutName
  //   }
  // }).filter(i => i.seriesUri === params.series) : null;

  // // Group series into arrays
  // const groupTabs = trimTabs ? groupBy(trimTabs, item => item.series) : null;
  // const currentSize = null //  modelLayoutName ? parseFloat(modelLayoutName.replace('-', '').trim()) : null;

  // const tabsRefactoredData = tabsData ? refactorSpecTabs(tabsData, url, context.params, groupTabs, currentSize) : null;
  // const tabsArr = tabsRefactoredData ? tabsRefactoredData.items : [];
  // // END TABS
  

  //

  var paramsWithModel;

  const compareDlEvent = {
    'event': 'jaycoEvent',
    'eventAction': 'CTA Click - Range Detail Page',
    'eventCategory': 'Research',
    'eventLabel': 'Compare'  
  }

  try  {
    paramsWithModel = getParamsWithModel(params, pageProps)
  } catch {
    paramsWithModel = params
  }

  const refactoredData = await refactorSeriesData(data, series, paramsWithModel, modelFloorplans, compareDlEvent);

  // seo
  const title = get(pageProps, 'data.seriesBy.title', null);
  const seo = get(pageProps, 'data.seriesBy.seo', null);
  const assignedDomains = get(pageProps, 'data.seriesBy.acf_domains.assignedDomains', []); 

  // breadcrumbs
  // Hardcoded due to CMS range post permalink is different with site page URLs
  const breadcrumbs = {
    list: [
      {
        link: {
          title: 'Home',
          href: '/',
          target: '_self',
          assignedDomains
        },
        active: false
      },
      {
        link: {
          title: 'Range',
          href: '/range',
          target: '_self',
          assignedDomains
        },
        active: false
      },
      {
        link: {
          title: startCase(toLower(params.range)),
          href: `/range/${params.range}`,
          target: '_self',
          assignedDomains
        },
        active: false
      },
      {
        link: {
          title,
          href: `/range/${params.range}/${params.series}`,
          target: '_self',
          assignedDomains
        },
        active: true
      }
    ]
  };

  const disclaimerVals = get(pageProps, 'data.seriesBy.acf_series.seriesDisclaimer', null)
  const disclaimers = disclaimerVals ? disclaimerVals.map(item => {
    return get(item, 'acf_disclaimer.disclaimerText', '')
  }).reduce((accumulator, currentValue) => {
    return accumulator + currentValue
  }) : null

  const motorisedModel = get(pageProps, 'data.seriesBy.acf_motorised.motorisedModel', null);

  // JAY25748
  if (typeof refactoredData.cbData != 'undefined' && refactoredData.cbData.length > 0) {
    var floorplanMotorised = {};
    for (var c=0; c<refactoredData.cbData.length; c++) {
      if (refactoredData.cbData[c].type == 'floorplan') {
        var bgColour = refactoredData.cbData[c].data.background;
        refactoredData.cbData[c].data = await getModelFloorPlanData({params: refactoredData.params, seriesPageProps: pageProps });
        refactoredData.cbData[c].data.background = bgColour;
        refactoredData.cbData[c].data.title = get(pageProps, 'data.seriesBy.acf_series_v2.sv2FloorPlansSectionTitle', null)
        refactoredData.cbData[c].data.link360PreTitle = get(pageProps, 'data.seriesBy.acf_series_v2.sv2FloorPlansLink360Pretitle', null)
        refactoredData.cbData[c].data.link360Title = get(pageProps, 'data.seriesBy.acf_series_v2.sv2FloorPlansLink360Title', null)
        
        if (refactoredData.params && refactoredData.params.range && (refactoredData.params.range.indexOf('motorhome') !== -1) || (refactoredData.params.range.indexOf('campervan') !== -1) || (refactoredData.params.series.indexOf('motorhome') !== -1 || (refactoredData.params.series.indexOf('campervan') !== -1) )) {
          refactoredData.cbData[c].data.type = 'campervan'
        }

        if (refactoredData.cbData[c].anchorId) {
          refactoredData.cbData[c].data.preTitle = refactoredData.cbData[c].anchorId 
        }
        
        if (motorisedModel) {
          refactoredData.cbData[c].type = 'floorplanMotorised';
          refactoredData.motorised = true;
          floorplanMotorised = refactoredData.cbData[c]
        }
        // console.log('series floorplan motorised >>>');
        // console.dir(refactoredData.cbData[c].data,{depth:null});
      }
    }
    for (var c=0; c<refactoredData.cbData.length; c++) {
      if (refactoredData.cbData[c].type == 'motorisedTableComparison' && floorplanMotorised) {
        var mtcMM = refactoredData.cbData[c].data.motorisedModels;
        var fmDM = floorplanMotorised.data.models;
        for (var mtC=0; mtC<mtcMM.length; mtC++) {
          for (var mC=0; mC<fmDM.length; mC++) {
            if (fmDM[mC].name == get(mtcMM[mtC], 'acf_motorised_model.motorisedMakeModelName', null)) {
              refactoredData.cbData[c].data.models.push({
                image: fmDM[mC].floorplans[0].floorplan.image,
                title: fmDM[mC].name,
                text: get(mtcMM[mtC], 'acf_motorised_model.motorisedDescription', null),
                //specs: get(fmDM[mC], `floorplans[0].floorplan.specsFeatures.modal.models[${mC}].floorplans[0].sections[0].features`, null),
                specs: [
                  {title: 'Engine', value: get(mtcMM[mtC], 'acf_motorised_model.motorisedComparisonTable.engine', null)},
                  {title: 'Transmission', value: get(mtcMM[mtC], 'acf_motorised_model.motorisedComparisonTable.transmission', null)},
                  {title: 'Fuel Capacity', value: get(mtcMM[mtC], 'acf_motorised_model.motorisedComparisonTable.fuelEconomy', null)},
                  {title: 'Driven Wheels', value: get(mtcMM[mtC], 'acf_motorised_model.motorisedComparisonTable.drivenWheels', null)},
                  {title: 'Performance (Power-kW and Torque-Nm)', value: get(mtcMM[mtC], 'acf_motorised_model.motorisedComparisonTable.performance', null)},
                  {title: 'Warranty', value: get(mtcMM[mtC], 'acf_motorised_model.motorisedComparisonTable.warranty', null)},
                  {title: 'Roadside Assistance', value: get(mtcMM[mtC], 'acf_motorised_model.motorisedComparisonTable.roadsideAssistance', null)},
                ],
                cta: {title: `View ${fmDM[mC].name} Specs`}
              });
              if (typeof refactoredData.cbData[c].data.modal == 'undefined') {
                refactoredData.cbData[c].data.modal = get(fmDM[mC], 'floorplans[0].floorplan.specsFeatures.modal', []);
              }
            }
          }
        }
        delete refactoredData.cbData[c].data.motorisedModels;
        // console.log('motorisedTableComparison3 >>>');
        // console.dir(refactoredData.cbData[c].data,{depth:null});
      }  
    }
  }
  
  // console.log('series refactoredData.cbData >>>');
  // console.dir(refactoredData.cbData,{depth:null});
  const rangeId =  get(pageProps, 'data.seriesBy.acf_series.seriesRange[0].id', null);
  const rangeTitle =  get(pageProps, 'data.seriesBy.acf_series.seriesRange[0].title', null);
  const seriesId =  get(pageProps, 'data.seriesBy.id', null);

  var endTime = new Date().getTime();

  console.info(`${title} getStaticProps / took ${(endTime - startTime) / 1000} seconds`);

  return {
    props: {
      meta: {
        title,
        seo,
        assignedDomains
      },
      breadcrumbs,
      params,
      disclaimers,
      rates: refactorFinanceRates(pageProps, countryCode),
      rangeId,
      rangeTitle,
      seriesId,
      ...refactoredData,
      mobilePaddingBottom: refactoredData.heroBanner ? true : false
      // new: {
      //   tabs: {
      //     data: tabsArr,
      //     activeIndex: 0,
      //   },
      //   filteredFp,
      // }
    }
  }
}
  
export default withWidth(SeriesPage);